import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-grid-panel-content',
    templateUrl: './grid-panel-content.component.html',
    styleUrls: [
        './grid-panel-content.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GridPanelContentComponent implements OnInit
{
    private readonly cols: number[] = [1, 2, 3];
    private readonly rows: number[] = [1, 2];
    @Input() set nbCol (value: number)
    {
        if (value && this.cols.includes(value))
        {
            this.klassCol = `grid-content-col grid-content-col-${value}`;
        }
    }
    @Input() set nbRow (value: number)
    {
        if (value && this.rows.includes(value))
        {
            this.klassRow = `grid-content-row grid-content-row-${value}`;
        }
    }
    public klass: string;
    private klassCol: string = 'grid-content-col-1';
    private klassRow: string = '';

    ngOnInit (): void
    {
        this.klass = `${this.klassCol} ${this.klassRow}`.trim();
    }
}
